// CSV 업로드 양식(컬럼 1행 + '#' 설명 1행) 생성.
export const escapeCell = (value) => {
    const str = String(value ?? '');
    return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

/**
 * 컬럼명 1행 + '#' 로 시작하는 설명 1행만 담긴 빈 양식을 만든다.
 * 설명 행은 업로드 시 주석(comments: '#')으로 무시되므로 그대로 두고 작성하면 된다.
 */
export const buildTemplateCsv = (columns) => {
    const header = columns.map(column => escapeCell(column.key)).join(',');
    const description = columns.map((column, idx) => idx === 0
        // 첫 칸은 따옴표 없이 '#' 로 시작해야 주석으로 인식된다.
        ? `#${String(column.desc || '').replace(/[",]/g, ' ')}`
        : escapeCell(column.desc)).join(',');

    return `﻿${header}\r\n${description}\r\n`;
};


// 업로드 파서가 unix(초)/날짜 문자열 둘 다 받으므로 사람이 읽기 쉬운 날짜로 내보낸다.
const DATE_KEYS = ['openDate', 'closeDate', 'begin', 'end'];
const pad = (n) => String(n).padStart(2, '0');
const formatUnix = (unix) => {
    const d = new Date(unix * 1000);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};
const toCell = (key, value) => {
    if (DATE_KEYS.includes(key) && Number(value) > 0) return formatUnix(Number(value));
    if (value !== null && typeof value === 'object') return JSON.stringify(value);
    return value;
};

/** 업로드 양식(컬럼 + '#' 설명 행) 뒤에 rows 를 채운 CSV. 그대로 다시 업로드할 수 있다. */
export const buildDataCsv = (columns, rows) => buildTemplateCsv(columns)
    + rows.map(row => columns.map(({key}) => escapeCell(toCell(key, row[key]))).join(',') + '\r\n').join('');

export const downloadCsv = (text, fileName) => {
    const url = URL.createObjectURL(new Blob([text], {type: 'text/csv;charset=utf-8;'}));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
};
